import { Card, Grid, SvgIcon, useTheme } from '@mui/material';
import { FONT_WEIGHT_BOLD, COLOR_CARNATION } from '../../popTheme';

export const IntroCard = ({ title, icon }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        background: COLOR_CARNATION,
        color: 'white',
        borderRadius: '0.75rem',
        [theme.breakpoints.up('xs')]: {
          height: '9.75rem',
          width: '9.75rem',
        },
        [theme.breakpoints.up('sm')]: {
          width: '18rem',
          height: '18rem',
        },
      }}
    >
      <Grid
        container
        direction={'column'}
        wrap="nowrap"
        sx={{
          height: '100%',
          [theme.breakpoints.up('xs')]: {
            p: '1rem',
          },
          [theme.breakpoints.up('sm')]: {
            p: '2rem',
          },
        }}
      >
        <Grid
          item
          xs={10}
          sx={{
            [theme.breakpoints.up('sm')]: {
              typography: 'h4',
            },
            [theme.breakpoints.only('xs')]: {
              typography: 'subtitle',
              fontWeight: FONT_WEIGHT_BOLD,
            },
          }}
        >
          {title}
        </Grid>
        <Grid item align="right" xs={2}>
          <SvgIcon
            component={icon}
            inheritViewBox
            sx={{
              [theme.breakpoints.up('sm')]: {
                height: '2.5rem',
                width: '2.5rem',
              },
              [theme.breakpoints.only('xs')]: {
                height: '1.5rem',
                width: '1.5rem',
              },
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
